import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  withStyles,
} from "@material-ui/core";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";

/**
 * Matches Idlecontainer session-expired modal: same typography, icon treatment, and CTA.
 * Full-viewport backdrop via Dialog (consistent with existing "session expired" pattern).
 */
const styles = {
  // 25% narrower than default MUI Dialog `sm` (~600px → 450px)
  dialogPaper: {
    maxWidth: 450,
    width: "100%",
  },
  sessionExpiredTitle: {
    display: "flex",
    alignItems: "center",
  },
  sessionExpiredIcon: {
    color: "#ff0000",
    marginRight: "10px",
    fontSize: "25px",
  },
  sessionExpiredText: {
    fontSize: "14px",
    fontFamily: "'Poppins'",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#000000",
  },
  loginText: {
    fontSize: "13px",
    fontFamily: "'Poppins'",
    fontWeight: 600,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.5",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#ffffff",
    textTransform: "none",
  },
  loginButton: {
    padding: "10px 0px",
    margin: "0px 10px 10px 0px",
    width: "85px",
    borderRadius: "50px",
    background: "#FF0000",
    "&:hover": {
      background: "#c50000",
      cursor: "pointer",
    },
  },
};

const defaultTitle = "Session Error";
const defaultMessage =
  "We could not verify your session. This may be due to an expired login or a network issue. Please log in again to continue.";

function SessionErrorScreen({ classes, onLoginAgain, title, message, actionLabel }) {
  return (
    <Dialog
      open
      maxWidth={false}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={classes.sessionExpiredTitle}>
        <QueryBuilderIcon className={classes.sessionExpiredIcon} />
        {title}
      </DialogTitle>
      <DialogContent>
        <span className={classes.sessionExpiredText}>{message}</span>
      </DialogContent>
      <DialogActions>
        <Button className={classes.loginButton} type="button" onClick={onLoginAgain}>
          <span className={classes.loginText}>{actionLabel}</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SessionErrorScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  onLoginAgain: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  actionLabel: PropTypes.string,
};

SessionErrorScreen.defaultProps = {
  title: defaultTitle,
  message: defaultMessage,
  actionLabel: "LOGIN",
};

export default withStyles(styles)(SessionErrorScreen);
